<template>
<div class="chapter">
<div class="inner_page">
<table class="chapter-title-corner-decorations" width="100%"><tbody><tr><td class="chapter-title-corner-decoration-left-column"><div class="chapter-title-corner-decoration-left-column"><img alt="image" class="chapter-title-corner-decoration-left" src="d2d_images/chapter_title_corner_decoration_left.png"/></div></td><td class="chapter-title-corner-decoration-middle-column"> </td><td class="chapter-title-corner-decoration-right-column"><div class="chapter-title-corner-decoration-right-column"><img alt="image" class="chapter-title-corner-decoration-right" src="d2d_images/chapter_title_corner_decoration_right.png"/></div></td></tr></tbody></table><div class="chapter-title"><div class="chapter-title-decoration-above"><div class="chapter-title-decoration-above-inner"><img alt="image" class="chapter-title-decoration-above" src="d2d_images/chapter_title_above.png"/></div></div><h1 class="chapter-title"><a href="#/c006#TOC">Dedica</a><a id="Dedication"></a></h1><a id="Dedication">
<div class="chapter-title-decoration-below"><div class="chapter-title-decoration-below-inner"><img alt="image" class="chapter-title-decoration-below" src="d2d_images/chapter_title_below.png"/></div></div></a></div><p style="font-style: italic; text-align: center; text-indent: 0"><a id="Dedication">A Valerie.</a></p><a id="Dedication">
<p style="font-style: italic; text-align: center; text-indent: 0">Sono piuttosto emozionato per i nostri secondi venticinque anni.</p>
</a><p style="font-size: large; page-break-before: always; text-align: center; text-indent: 0"><a id="Dedication"></a><a id="TitlePage"><img alt="image" height="768" src="d2d_images/image004.jpg" width="480"/></a></p><a id="TitlePage">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c007.vue?4b163bee